import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';


export class gamePartyBox extends cDisplay {

  private dropTargtes:cSprite[]
  private items:any[]
  private score: number 
  private complted:any
  private slot_idx:number[]

  init(){
    super.init()
    console.log('GAME gamePartyBox')
    var cS:cScene = this.scene as cScene;
    this.score = 4;
    this.complted = {}
    this.items = []
    var a,b,c;

    this.slot_idx = [1,1,1,1,1,1,1]

    for (a=0; a < 4; a++) this.appendCharString(1);
    for (a=0; a < 4; a++) this.appendCharString(2);
    for (a=0; a < 4; a++) this.appendCharString(3);
    for (a=0; a < 4; a++) this.appendCharString(4);
    for (a=0; a < 4; a++) this.appendCharString(5);


    setTimeout(()=>{
      c=0;
      for (a=0; a < 2; a++){
        for (b=0; b < 10; b++){     
          if (this.items[c]){
            this.appendChar(cS,'f'+c,this.items[c],b*110,a*385)
            c++
  
          }     
        }
      }  
    },200);


    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
      switch (b.command){
        case 'handle_start_drag':
          var tg = cS.getByName('char_container') as cContainer
          tg.bringToTop( tg.getByName(b.payload.drag) )
          break;
        case 'handle_drop':

          //check slot 1
          var d1 = this.checkSlot( this.getByName('drop_1'),1 )
          if (!this.checkContent(cS,d1,1)) return

          var d2 = this.checkSlot( this.getByName('drop_2'),2 )
          if (!this.checkContent(cS,d2,2)) return

          var d3 = this.checkSlot( this.getByName('drop_3'),3 )
          if (!this.checkContent(cS,d3,3)) return

          var d4 = this.checkSlot( this.getByName('drop_4'),4 )
          if (!this.checkContent(cS,d4,4)) return

          var d5 = this.checkSlot( this.getByName('drop_5'),5 )
          if (!this.checkContent(cS,d5,5)) return


          var score = [d1,d2,d3,d4,d5].reduce((pay:any,val:any)=>{return (val[0]==val[1] && val[0] == 4)?pay+1:pay},0 )

          console.log('HANDLE_DROP',score)
          break;
        case 'create':
          break;
      }
    })
  }

  checkContent(cS,val,idx){
    if (val[0] === 999){
      cS.triggerSceneEvent('overflow',{slot:idx})
      return false
    }
    if (val[1] === 4 && val[0] !== val[1]){
      cS.triggerSceneEvent('wrongmix',{slot:idx})
      return false
    }
    if (val[1] === 4 && val[0] === val[1]){
      var t 
      t = cS.getByName('slot_'+idx)
      t.visible = true

      t = cS.getByName('drop_'+idx)
      t.dragitem.forEach( (obj)=>obj.modules.drag.enabled=false )
      
      if (!this.complted[idx]){
        this.complted[idx] = 'done';

        cS.triggerSceneEvent('slotdone',{
          slot:idx, 
          score: 5,
          type:'party',
          alldone: Object.keys(this.complted).length == 5 ? 'yes' : 'no' 
        })
      }
      return true
    }
    return true
  }

  

  checkSlot(obj,idx){
    if (!obj.dragitem) return [-1,0]
    if (obj.dragitem.length > 4) return [999,0]
    var res = obj.dragitem.reduce( (pay:number,val:MiniFig)=>{      
      if (val.slot == idx) {
        pay++
        val.y = 670
        val.hideBubble()
        val.modules.drag.enabled = false;
      }
      return pay
    },0)
    return [res,obj.dragitem.length]
  }


  buildScene(){    
    super.buildScene();
    this.dropTargtes = this.getByName('drop_container').getAll()
  }
  

  rnd(){
    return Math.floor(Math.random()*5)+1;
  }

  appendCharString( idx ){
    var n = this.slot_idx[idx] ++
    var s = `${this.rnd()}:${this.rnd()}:${this.rnd()}:${idx}`
    this.items.splice( Math.floor(Math.random()*this.items.length),0,s)   
  }


  appendChar(cS,nm,asset,xx,yy){
    var c = new MiniFig(cS,{
      name:nm,
      asset:asset,
      id:'',
      type:'',
      ofs:`${400+xx}x${50+yy}`,
      dragtarget:'drop_container',
      dragoptions:'{"compare":"area","snap":false,"return":true,"type":"multiple"}'})

    var tg = cS.getByName('char_container') as cContainer
    cS.add.existing( c )
    tg.add(c)
  }


}

var bubbleCount = {}


class MiniFig extends cContainer {

  public slot:number
  private bubble;

  constructor(sc:cScene, data: ScreenItem){
    super(sc,data)

    let [h,b,l,bbl] = data.asset.split(':')

    var shf = 120;
    var feet = new Phaser.GameObjects.Sprite(sc,0,103+shf,'figures',`feet_${l}.png` )
    feet.setOrigin(0,0)
    this.add(feet)

    var body = new Phaser.GameObjects.Sprite(sc,0,36+shf,'figures',`body_${b}.png` )
    body.setOrigin(0,0)
    this.add(body)

    var head = new Phaser.GameObjects.Sprite(sc,0,0+shf,'figures',`head_${h}.png` )
    head.setOrigin(0,0)
    this.add(head)

    var bblname = ['','qpd','pas','bunte','ulf','dss'][ bbl ]
    if (!bubbleCount[bblname]) bubbleCount[bblname]=0;
    bubbleCount[bblname]++

    this.bubble = new Phaser.GameObjects.Sprite(sc,0,-120+shf,'figures',`bubble_${bblname}_${bubbleCount[bblname]}.png` )
    this.bubble.setOrigin(0,0)
    this.add(this.bubble)

    this.slot = Number(bbl)

  }

  hideBubble(){
    this.bubble.visible = false;
  }

}